module.exports = "./img/desktop_logo.1510b14.png";